// 保存原始的 fetch 方法
const originalFetch = window.fetch;

// 定义辅助函数来从文档的 Cookie 中读取特定名称的值
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

// 重写 fetch 方法
window.fetch = async function(input, init = {}) {
  // 从 Cookie 中获取 csrfToken
  const csrfToken = getCookie('csrfToken');
  
  // 如果没有提供 headers，则创建一个新的空对象
  if (!init.headers) {
    init.headers = {};
  }
  
  // 确保 headers 是一个对象
  if (!(init.headers instanceof Object)) {
    throw new TypeError('请求头必须是一个对象');
  }

  // 添加或更新 'x-csrf-token' 请求头
  init.headers['x-csrf-token'] = csrfToken || '';

  // 调用原始的 fetch 方法
  return await originalFetch(input, init);
};

export default window.fetch;